import { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import LoadingScreen from "../LoadingScreen";

import vehicleMasterData, {vehicleAction} from "../../store/VehicleMasterERP";

// Importing Components
import HeaderInformation from "./VehicleMaster/HeaderInformation";
import TyresLocation from "./VehicleMaster/TyresLocation";
import TankerCompartments from "./VehicleMaster/TankerCompartments";
import KmReadingAndValue from "./VehicleMaster/KmReadingAndValue";

const VehicleMaster = () => {
  const [tabs, setTabs] = useState([
    {
      id: 1,
      title: "Header Information",
      content: <HeaderInformation />,
    },
    {
      id: 2,
      title: "TyresLocation",
      content: <TyresLocation />,
    },
    {
      id: 3,
      title: "Tanker Compartments",
      content: <TankerCompartments />,
    },
    {
      id: 4,
      title: "KM Reading and Value",
      content: <KmReadingAndValue />,
    },
  ]);

  const addItem = vehicleAction((state) => state.addItem);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const handleTabSelect = (index) => {
    setSelectedTabIndex(index); // Track selected tab index
    // if (index < 3) {
    //   // Only swap when selecting from row 1
    //   setTabs((prevTabs) => {
    //     const row1 = prevTabs.slice(0, 3);
    //     const row2 = prevTabs.slice(3, 6);
    //     return [...row2, ...row1]; // Swap rows
    //   });
    //   setSelectedTabIndex(index + 3); // Adjust selected tab index after swapping
    // }
  };

  return (
       <div className="min-h-100vh">
      <AllPagesNavbar />
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">{"VEHICLE RELATED-VEHICLE MASTER"}</h1>
      </header>

      <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
        <IoDocumentOutline
          size={24}
          onClick={() => {
            window.location.reload()
          }}
          className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
        />
        <FaSave
          size={24}
          onClick={() => {
            addItem("SAVE")
          }}
          className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
        />
        <GiCrossMark
          size={24}
          className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
        />
        <IoPrintSharp
          size={24}
          className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
        />
      </div>

      {/* Main tab */}
      <div className="mt-1">
        <Tabs selectedIndex={selectedTabIndex} onSelect={handleTabSelect}>
          <TabList className="grid grid-cols-4 gap-1 border-b-2 border-gray-300">
            {tabs.map((tab, index) => (
              <Tab
                key={tab.id}
                className={`px-4 py-1 cursor-pointer text-xs text-red-500 rounded-t-md hover:bg-gray-300 ${
                  index === selectedTabIndex
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200"
                }`}
              >
                {tab.title}
              </Tab>
            ))}
          </TabList>
          <div className="border border-gray-300 rounded-b-md">
            {/* {tabs[selectedTabIndex]?.content} */}
             {tabs.map((tab, index) => (
    <div
      key={tab.id}
      className={index === selectedTabIndex ? "block" : "hidden"}
    >
      {tab.content}
    </div>
  ))}
          </div>
        </Tabs>
      </div>

    </div>
  );
};
export default VehicleMaster;
